import * as React from "react";
import { classNames } from "src/common/classNames";

import * as styles from "./ToolBox2.module.less";

type PropsToolBox2 = {
  children: React.ReactNode | React.ReactNode[];
  mainTool?: React.ReactNode;
  extraTools?: React.ReactNode | React.ReactNode[];
  toolsClass?: string;
  paddingMode?: "page";
  footer?: React.ReactNode;
};

/**
 * Распространённый паттерн: сверху строка с кнопками, а остальное место занимает children
 * Предыдущий вариант ToolBox добавляет лишние паддинги, из-за этого не подходит под многие кейсы
 * и создает расхождения в лейауте, поэтому был сделан новый, облегченный вариант.
 * Я не стал менять ToolBox, т.к. он используется в большом количестве мест и менять его было бы нецелесообразно,
 * лучше постепенный переход на ToolBox2.
 */
export const ToolBox2: React.FC<PropsToolBox2> = ({
  children,
  mainTool,
  extraTools,
  toolsClass,
  paddingMode,
  footer,
}) => {
  const getTools = () => {
    if (!mainTool && !extraTools) return null;
    return (
      <div className={classNames([styles.tools, toolsClass])}>
        {mainTool && <div className={styles.mainTool}>{mainTool}</div>}
        {extraTools && <div className={styles.extraTools}>{extraTools}</div>}
      </div>
    );
  };
  return (
    <div
      className={classNames([
        styles.box,
        [paddingMode === "page", styles.page],
      ])}
    >
      {getTools()}
      <div className={styles.content}>{children}</div>
      {footer}
    </div>
  );
};
